import { request } from '../utils/https/request'
interface getHomePageBackgroundData {
    pid: number
}
interface getTopBarItemsData {
    cid: number
}
interface getMessageByTopBarItemIDData {
    aid: number
}

/**
 * 获取主页的背景视频&图片
 * @param data 
 * @returns 
 */
export const getHomePageBackground = (data: getHomePageBackgroundData) => {
    return request({ url: '62b3de173ba51', method: 'POST', data })
}
/**
 * 获取主页的背景视频&图片
 * @param {Array<number>} id  传广告id
 * @returns 
 */
export const getAdImgAndVideo = (id: number) => {
    try {
        const src = getHomePageBackground({
            pid: id
        })
        return src
    } catch (e) { console.debug(e) }
}

/**
 * 获取顶部栏的item项
 * @param {number} data 公司id已经配好
 * @returns 
 */
export const getTopBarItems = (data: getTopBarItemsData) => {
    return request({ url: '62b3de55dd9bd', method: 'POST', data })
}
/**
 * 根据顶部栏id获取页面内容
 * @param {Array<number>}  data 
 * @returns 
 */
export const getMessageByTopBarItemID = (data: getMessageByTopBarItemIDData) => {
    return request({ url: '62b42757da89c', method: 'POST', data })
}
/**
 * 根据顶部栏id获取页面内容
 * @param {number} id  传递页面id
 * @returns 
 */
export const getPageMessage = async (id: number) => {
    try {
        const res = await getMessageByTopBarItemID({
            aid: id
        })
        return res;
    } catch (e) { console.error(e); }
}
